const SELECTOR = '[data-ordinary-buy-now]';

function showError(component, message) {
  const error = component?.querySelector('[ref="addToCartTextError"]');
  if (error) {
    error.classList.remove('hidden');
    const textNode = [...error.childNodes].find((node) => node.nodeType === Node.TEXT_NODE && node.textContent.trim());
    if (textNode) textNode.textContent = ` ${message}`;
    else error.append(document.createTextNode(` ${message}`));
  }

  const liveRegion = component?.querySelector('[ref="liveRegion"]');
  if (liveRegion) liveRegion.textContent = message;
}

async function buyNow(button) {
  if (button.disabled || button.dataset.loading === 'true') return;

  const component = button.closest('product-form-component');
  const form = component?.querySelector('form[action*="/cart/add"]');
  if (!component || !form) {
    showError(component, 'Unable to start checkout. Please try again.');
    return;
  }

  button.dataset.loading = 'true';
  button.disabled = true;
  button.setAttribute('aria-busy', 'true');

  try {
    const formData = new FormData(form);
    const variantId = formData.get('id');
    if (!variantId) throw new Error('Please select an available option.');

    const response = await fetch(window.Theme?.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json' },
      body: formData,
    });
    const result = await response.json();
    if (!response.ok || result.status) throw new Error(result.description || result.message || 'Unable to add this item.');

    window.location.assign('/checkout');
  } catch (error) {
    showError(component, error?.message || 'Unable to start checkout. Please try again.');
    button.disabled = false;
    button.removeAttribute('aria-busy');
    delete button.dataset.loading;
  }
}

if (!window.__ordinaryBuyNowBound) {
  window.__ordinaryBuyNowBound = true;
  document.addEventListener('click', (event) => {
    const button = event.target.closest?.(SELECTOR);
    if (!button) return;
    event.preventDefault();
    buyNow(button);
  });
}
